import {useEffect, useMemo} from 'react'
import classNames from 'classnames'

import {
  orderTagOptionsSelector,
  orderTagOptionTokensSelector,
  orderTagsHaveLoadedSelector,
} from '../../../../data/orderTags.js'
import {useSelector} from '../../../../store.js'
import {getConditionOption} from './conditionalOptions.js'
import ManageTagFilter from '../../../../common/components/ManageTagFilter.js'
import {TAG_TYPE__ORDER} from '../../../../common/constants/Tags.js'
import {hasOrderManageTagPermissionSelector} from '../../../../data/me.js'
import {showEditTagModal} from '../../../../common/components/Modal/EditTagModal.js'

export default function ConditionValueOrderTagSelect({
  condition,
  ruleID,
  index,
  error,
  onChange,
}) {
  const option = getConditionOption(condition)
  const valueParam = option.getValueParam(condition)
  const value = option.getValue(condition)

  const orderTagOptions = useSelector(orderTagOptionsSelector)
  const orderTagOptionTokens = useSelector(orderTagOptionTokensSelector)
  const hasOrderManageTagPermission = useSelector(
    hasOrderManageTagPermissionSelector,
  )
  const orderTagsHaveLoaded = useSelector(orderTagsHaveLoadedSelector)

  const tagQuantityMap = useMemo(
    () =>
      orderTagOptions.reduce((prev, option) => {
        prev[option.entity.id] = option.entity.id === value ? 'all' : 'none'

        return prev
      }, {}),
    [value, orderTagOptions],
  )

  useEffect(() => {
    // If someone deletes a tag that is yet-to-be-saved on a rule, then default it.
    if (
      valueParam === 'id' &&
      orderTagOptions.length > 0 &&
      (!value ||
        (orderTagsHaveLoaded &&
          !orderTagOptions.find((option) => option.entity.id === value)))
    ) {
      onChange(orderTagOptions[0].value)
    }
  }, [value, valueParam, orderTagOptions, orderTagsHaveLoaded])

  if (valueParam === 'id' && value === null) {
    return null
  }

  return (
    <div className={classNames('flex-item', {error})}>
      {valueParam === 'id' ? (
        <>
          <ManageTagFilter
            label="Select a tag"
            dropdown={`RULE_ORDER_TAG_CONDITION_FILTER__${ruleID}__${index}`}
            buttonClassName="fs-00"
            onSelect={(tag) => onChange(tag.id)}
            tagOptions={orderTagOptions}
            tagOptionTokens={orderTagOptionTokens}
            tagQuantityMap={tagQuantityMap}
            hasManageTagPermission={hasOrderManageTagPermission}
            tagType={TAG_TYPE__ORDER}
            onCreateAndApplyClick={() =>
              showEditTagModal(TAG_TYPE__ORDER, null, {
                addOrderTagToRuleOnChange: onChange,
              })
            }
            isSingleSelect
            hasErrors={!!error}
          />
          {error && <small className="error error-message">{error}</small>}
        </>
      ) : (
        <input
          className="input--h-29 margin-bottom-0"
          type="text"
          name="value"
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
      )}
    </div>
  )
}
